const TRANSLATION = {
  common: {
    loading: 'Memuatkan',
  },
  i18n: {
    English: 'Bahasa Inggeris',
    Spanish: 'Bahasa Sepanyol',
    Russian: 'Bahasa Rusia',
    'Portuguese (Brazil)': 'Bahasa Portugis (Brazil)',
    Indonesian: 'Bahasa Indonesia',
    Czech: 'Bahasa Czech',
    German: 'Bahasa Jerman',
    French: 'Bahasa Perancis',
    Italian: 'Bahasa Itali',
    Dutch: 'Bahasa Belanda',
    Polish: 'Bahasa Poland',
    Vietnamese: 'Bahasa Vietnam',
    Turkish: 'Bahasa Turki',
    Ukrainian: 'Bahasa Ukraine',
    Chinese: 'Bahasa Cina (Ringkas)',
    'Traditional Chinese': 'Bahasa Cina (Tradisional)',
    Japanese: 'Bahasa Jepun',
    Korean: 'Bahasa Korea',
    Arabic: 'Bahasa Arab',
    Persian: 'Bahasa Parsi',
    Thai: 'Bahasa Thai',
    Hindi: 'Bahasa Hindi',
    Malay: 'Bahasa Melayu',
    province: {
      Hebei: 'Wilayah Hebei',
      Shanxi: 'Wilayah Shanxi',
      Liaoning: 'Wilayah Liaoning',
      Jilin: 'Wilayah Jilin',
      Heilongjiang: 'Wilayah Heilongjiang',
      Jiangsu: 'Wilayah Jiangsu',
      Zhejiang: 'Wilayah Zhejiang',
      Anhui: 'Wilayah Anhui',
      Fujian: 'Wilayah Fujian',
      Jiangxi: 'Wilayah Jiangxi',
      Shandong: 'Wilayah Shandong',
      Henan: 'Wilayah Henan',
      Hubei: 'Wilayah Hubei',
      Hunan: 'Wilayah Hunan',
      Guangdong: 'Wilayah Guangdong',
      Hainan: 'Wilayah Hainan',
      Sichuan: 'Wilayah Sichuan',
      Guizhou: 'Wilayah Guizhou',
      Yunan: 'Wilayah Yunnan',
      Shaanxi: 'Wilayah Shaanxi',
      Gansu: 'Wilayah Gansu',
      Qinghai: 'Wilayah Qinghai',
      Taiwan: 'Wilayah Taiwan',
      Guangxi: 'Wilayah Autonomi Zhuàng Guangxi',
      Neimenggu: 'Wilayah Autonomi Mongolia Dalam',
      Tibet: 'Wilayah Autonomi Tibet',
      Ningxia: 'Wilayah Autonomi Hui Ningxia',
      Xinjiang: 'Wilayah Autonomi Uyghur Xinjiang',
      HongKong: 'Wilayah Pentadbiran Khas Hong Kong',
      Macau: 'Wilayah Pentadbiran Khas Macau',
      Beijing: 'Bandaraya Beijing',
      Tianjin: 'Bandaraya Tianjin',
      Shanghai: 'Bandaraya Shanghai',
      Chongqing: 'Bandaraya Chongqing',
    },
  },
  pageHeader: {
    product: 'Produk',
    tvcTest: 'Ujian Pengalaman TVC',
    tvcEval: 'Penilaian Kreatif TVC',
    contactUs: 'Hubungi Kami',
    Pricing: 'Harga',
    Dashboard: 'Mula Sekarang',
    signIn: 'Log masuk',
    signUp: 'Daftar Akaun',
    resourceCenter: 'Blog',
    all: 'Semua',
    news: 'Berita',
    insight: 'Wawasan',
    case: 'Kes',
  },
  productSwitch: {
    common: {
      comingSoon: 'Akan datang',
    },
    modal: {
      heroTitle: 'Sila pilih ujian yang anda mahu jalankan',
      heroSubtitle:
        'AdEff sentiasa bersedia untuk memberikan pandangan kreatif pelbagai dimensi apabila anda memerlukannya.',
      remainingTimes: 'Baki penggunaan: {{count}}',
      supportedAssets: 'Aset yang disokong',
      coreMetrics: 'Metrik teras',
      cognitiveNeuroscienceIndicators: 'Penunjuk kognitif-neural',
      consumerAttitudeIndicators: 'Indikator sikap pengguna',
      outputResult: 'Hasil output',
      dataReport: 'Laporan data',
      analysisReport: 'Laporan analisis',
      accessBackend: 'Mula Sekarang',
      tabs: {
        tvc: 'Ujian Kreatif Mendatar',
        portrait: 'Ujian Kreatif Menegak',
      },
      cards: {
        tvcQuick: {
          title: 'Mendatar-Ujian pantas',
          descriptionHighlight:
            'Nilai kreatif dengan pantas untuk mendorong keputusan berasaskan data',
        },
        tvcBase: {
          title: 'Diagnosa Kreatif-Mendatar',
          descriptionHighlight:
            'Perhalusi butiran kreatif dengan cadangan pengubahsuaian yang boleh dilaksanakan',
          value1: 'Kreatif TVC/OTV 10–60 saat',
          value2: 'Penunjuk kognitif-neural',
        },
        tvcSurvey: {
          title: 'InsightPro-Mendatar',
          descriptionHighlight:
            'Analisis kreatif pelbagai dimensi dengan panduan pengoptimuman strategik',
          value1: 'Kreatif TVC/OTV 10–60 saat',
          value2: 'Penunjuk kognitif-neural',
        },
        portraitQuick: {
          title: 'Menegak-Ujian pantas',
          descriptionHighlight:
            'Nilai kreatif dengan pantas untuk mendorong keputusan berasaskan data',
        },
        portraitBase: {
          title: 'Diagnosa Kreatif-Menegak',
          descriptionHighlight:
            'Perhalusi butiran kreatif dengan cadangan pengubahsuaian yang boleh dilaksanakan',
          value1: 'Kreatif menegak 5–90 saat',
          value2: 'Penunjuk kognitif-neural',
        },
        portraitSurvey: {
          title: 'InsightPro-Menegak',
          descriptionHighlight:
            'Analisis kreatif pelbagai dimensi dengan panduan pengoptimuman strategik',
          value1: 'Kreatif menegak 5–90 saat',
          value2: 'Penunjuk kognitif-neural',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Ujian Kreatif Mendatar',
          assetText: 'Untuk kreatif TVC/OTV 10-60 saat',
        },
        portrait: {
          bannerTitle: 'Ujian Kreatif Menegak',
          assetText: 'Untuk kreatif menegak 5-90 saat',
        },
      },
      items: {
        tvcQuick: {
          description: 'Bandingkan kreatif dengan cepat dan buat keputusan',
        },
        tvcBase: {
          title: 'Diagnosa Kreatif',
          description: 'Pengoptimuman saat demi saat untuk memperhalus kreatif',
        },
        tvcSurvey: {
          title: 'Wawasan Mendalam',
          description: 'Analisis menyeluruh untuk mengenal pasti isu utama',
        },
        portraitBase: {
          title: 'Diagnosa Kreatif',
          description: 'Pengoptimuman saat demi saat untuk memperhalus kreatif',
        },
        portraitQuick: {
          description: 'Bandingkan kreatif dengan cepat dan buat keputusan',
        },
        portraitSurvey: {
          title: 'Wawasan Mendalam',
          description: 'Analisis menyeluruh untuk mengenal pasti isu utama',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Kami menggunakan kuki',
    desc: 'Kami menggunakan kuki yang diperlukan untuk memastikan laman web kami berjalan lancar. Dengan persetujuan anda, kami turut menggunakan kuki analitik untuk menambah baik pengalaman pengguna anda. Lihat Polisi Kuki kami di Polisi Privasi.',
    btn1: 'Tolak Semua',
    btn2: 'Terima Semua',
    cookiePolicy: 'Polisi Kuki',
  },
  landing: {
    banner: {
      text1: 'Dikuasakan AI',
      text2: 'Iklan',
      text3: 'Pengujian',
      text4: 'Platform pengujian & pengoptimuman kreatif',
      feature1: 'Penyahkodan kandungan',
      feature2: 'Ramalan maklum balas',
      feature3: 'Integrasi data',
      feature4: 'Sintesis Kesimpulan',
      btn1: 'Dapatkan Demo',
      btn2: 'Cipta Projek',
    },
    info: {
      title:
        'Ramalan pantas prestasi kreatif iklan anda untuk memaksimumkan ROI dengan Memanfaatkan Model Bahasa Besar Multimodal Hipergraph (HMLLM)*',
      subTitle: '*Model ini dibina atas ujian neuromarketing meluas dan seni bina multi-ejen.',
      detail1: 'Pengujian Iklan Pantas',
      detail1Desc:
        'AdEff mengukur lengkung perhatian penonton sasaran, turun naik emosi, dan kadar penglibatan kandungan dalam masa 15 minit, serta menjana laporan penilaian terperinci beserta idea pengoptimuman yang boleh diambil tindakan.',
      detail2: 'Penilaian Masa Sebenar Iklan Terbaik',
      detail2Desc:
        'AdEff menganalisis pelbagai kreativiti iklan secara masa nyata, mengenal pasti yang berprestasi tinggi, dan memberikan cadangan dipacu AI untuk memaksimumkan impak kempen anda.',
      detail3: 'Suntingan Satu Klik, Jana Versi Berkesan dan Pelbagai',
      detail3Desc:
        'AdEff menyokong suntingan satu klik, membolehkan penciptaan pantas versi yang pelbagai dan berkesan untuk pelbagai senario komunikasi.',
    },
    advantages: {
      title: 'Kelebihan AdEff',
      item1Title: 'Tindak Balas Pantas',
      item1Desc: 'Laporan tersedia seawal <tmp>15 minit</tmp>.',
      item2Title: 'Model AI Unik',
      item2Desc: 'Model <tmp>AI eksklusif</tmp> berdasarkan maklum balas penonton.',
      item3Title: 'Carta Visual',
      item3Desc:
        '<tmp>Carta visual</tmp> + maklumat oleh AI, laporan boleh dijana dengan sekali klik.',
      item4Title: 'Julat Data Luas',
      item4Desc: 'Pangkalan data <tmp>50,000+</tmp> kreativiti.',
      item5Title: 'Pasukan Pakar',
      item5Desc: 'Sokongan dan bimbingan oleh <tmp>pasukan pakar</tmp>.',
    },
    service: {
      title: 'Pilihan Perkhidmatan AdEff',
      desc: 'Pilih perkhidmatan yang sesuai dengan keperluan anda',
      topTitle: 'Layan Diri Atas Talian',
      topRow1: 'Cipta dan lengkapkan ujian secara berdikari',
      topRow2: 'Carta visual + laporan dijana AI',
      topRow3: 'Analisis metrik neurosains objektif (penjejakan mata + EEG)',
      topRow4: 'Ujian model AI eksklusif',
      bottomTitle: 'Perkhidmatan Pasukan Pakar',
      bottomRow1: 'Ujian dicipta dan dilengkapkan oleh pakar',
      bottomRow2:
        'Analisis metrik neurosains objektif (penjejakan mata + EEG), dengan pilihan metrik subjektif',
      bottomRow3: 'Carta visual + laporan analisis pakar',
      bottomRow4: 'Ujian model AI eksklusif, dengan ujian sampel manusia sebenar sebagai pilihan',
    },
    footer: {
      title:
        'AdEff memanfaatkan Model Bahasa Besar Multimodal Hypergraph (HMLLM) untuk membina hubungan kompleks antara elemen visual, isyarat EEG dan data penjejakan mata melalui hipergraph, membolehkan pengujian pantas kreativiti iklan',
      email: 'Emel',
      belongDesc: 'Produk daripada <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Mula Sekarang',
  },
  contact: { title: 'Hubungi Kami', copy: 'Salin', message: { success: 'Berjaya disalin' } },
  pricing: {
    title: 'Pakar Pengujian dan Pengoptimuman Kreatif Dipacu AI',
    starter: {
      title: 'Permulaan',
      desc_1: 'Sesuai untuk ujian satu kali penggunaan, sedia digunakan selepas pembelian',
      desc_2: 'Sesuai untuk pengujian skala kecil, sedia digunakan selepas pembelian',
      timesDesc: 'Ujian <strong>{{count}}</strong> kali',
      timesDesc1: 'Ujian <strong>{{count}}</strong> kali',
      discount: 'Diskaun 50%',
      originPrice: 'Harga asal',
      desc2: 'Model AI eksklusif berdasarkan maklum balas penonton',
      desc3: 'Tindak balas pantas, laporan dapat dijana sepantas 15 minit',
      desc4: 'Carta visual yang kaya',
      desc5: 'Maklumat AI profesional',
      desc6: 'Pangkalan data dan penanda aras global',
      cardDesc1: 'Diskaun masa terhad, hanya {{pricePerTest}}',
      cardDesc2: 'Kuota ujian tidak luput',
    },
    premium: {
      time: 'kali',
    },
    unlimited: {
      title: 'Tanpa Had',
      cardDesc1: 'Serendah {{pricePerTest}}',
      cardDesc2: 'Kuota sah selama setahun',
      cardDesc3: 'Penanda aras proprietari tersuai',
      planDesc500: 'Nikmati 500 ujian sepanjang tahun',
      planDesc1000: 'Nikmati 1,000 ujian sepanjang tahun',
    },
    benefits: {
      title: 'Mengapa pilih AdEff?',
      subtitle: 'Dengan AdEff, anda boleh mendapat manfaat berikut:',
      expertSupport: 'Sokongan dan panduan pasukan pakar',
      moreNeedsTitle: 'Ada keperluan pembelian lain?',
      customPlanPrefix: 'Kami menyokong pelan fleksibel dan tersuai — hubungi kami di',
      customPlanSuffix: 'untuk penyelesaian eksklusif anda',
    },
    subscribeBtn: 'Langgan Sekarang',
    contactUs: 'Hubungi Kami',
  },
  login: {
    loginText: 'Log masuk',
    signUpText: '<tmp>Daftar</tmp> secara percuma',
    text1: 'Berjaya menyertai pasukan',
    text1Desc:
      'AdEff menggunakan HMLLM untuk membina hubungan hipergraph bagi pengujian kreatif iklan pantas.',
    text2: 'Pengguna telah menyertai syarikat',
    text3: 'Jemputan pasukan telah tamat tempoh',
    text4: 'Pautan jemputan pasukan tidak lagi sah.',
    optionText1: 'Sudah ada akaun?',
    optionText2: 'Belum ada akaun?',
    alertText1: 'Dengan mendaftar, saya bersetuju dengan',
    alertText2: 'Saya bersetuju dengan',
    termsOfService: 'Terma Perkhidmatan',
    privacy: 'Polisi Privasi',
    privacyTips: 'Sila tandakan kotak perjanjian sebelum mendaftar.',
    and: 'dan',
    or: 'atau',
    next: 'Seterusnya',
    googleLogin: 'Log masuk dengan Google',
    googleSignUp: 'Daftar dengan Google',
    loginWithEmail: 'Log masuk dengan Emel',
    signUpWithEmail: 'Daftar dengan Emel',
    password: 'Kata Laluan',
    emailAddress: 'Alamat Emel',
    enterEmail: 'Masukkan emel anda',
    enterPassword: 'Masukkan Kata Laluan anda',
    confirmPassword: 'Sahkan Kata Laluan',
    forgotPassword: 'Lupa kata laluan?',
    inconsistentPassword: 'Kata laluan tidak sepadan',
    verificationCode: 'Kod Pengesahan',
    emptyVerificationCode: 'Kod pengesahan tidak boleh dibiarkan kosong',
    enterVerificationCode: 'Masukkan Kod Pengesahan',
    sendedVerificationCode: 'Kod pengesahan telah dihantar ke emel anda',
    emailOrPasswordNotCorrect: 'emel atau kata laluan tidak betul.',
    message: {
      text1: 'Input tidak sah',
      text2: 'emel sudah didaftar',
      text3: 'Ralat pengesahan kod!',
      text4: 'Akaun belum diikat ke organisasi, sila ikat semula!',
      text5: 'Sila masukkan format emel yang betul',
      text6: 'Panjang minimum kata laluan ialah 12 aksara',
      text7: 'Kata laluan mesti mengandungi huruf besar, huruf kecil dan nombor',
      requestLimit: 'Had permintaan, sila cuba lagi kemudian',
    },
  },
  resetPwdPage: {
    submit: 'Hantar',
    emailNotFound: 'Sila periksa emel anda',
    emailHasSent: 'Emel telah dihantar ke {{email}}',
    checkYourInbox: 'Semak peti masuk anda',
    resetYourPassword: 'Tetapkan semula kata laluan anda',
    resetLinkHasSent:
      'Emel dengan pautan untuk menetapkan semula kata laluan telah dihantar ke alamat emel berkaitan dengan akaun anda',
    enterYourEmailAddress:
      'Masukkan alamat emel anda dan kami akan hantarkan pautan untuk mengeset semula kata laluan anda',
    didNotGetEmail: 'Tidak terima emel?',
    tryAgain: 'Cuba lagi',
    goBackToSign: 'Kembali ke log masuk',
    email: 'Emel',
    enterYourEmail: 'Masukkan alamat emel anda',
    resetPassword: 'Tetapkan semula kata laluan',
    resetPwdSuccess: 'Kata laluan berjaya ditetapkan semula',
    message: {
      resetLinkCodeError: 'Kod dalam pautan tidak sah',
      requestLimit: 'Had permintaan, sila cuba lagi kemudian',
    },
  },
  memberRequestPage: {
    title: 'Pengesahan Permintaan Ahli',
    subTitle: 'Permintaan Dari:',
    deny: 'Tolak',
    approve: 'Lulus',
    teamFull: 'Pasukan Penuh',
    yourTeamIsFull:
      'Pasukan anda penuh. Anda boleh hubungi kami untuk tambah keahlian atau keluarkan ahli lain.',
    manageMembers: 'Urus ahli di AdEff',
    requestApproved: 'Permintaan Telah Diterima',
    approvedDesc:
      'Anda telah meluluskan <tmp>{{name}}</tmp> menyertai pasukan anda; emel pemberitahuan telah dihantar secara automatik.',
    requestDeclined: 'Permintaan Ditolak',
    declinedDesc:
      'Anda telah menolak <tmp>{{name}}</tmp> menyertai pasukan anda; emel pemberitahuan telah dihantar secara automatik.',
  },
  infoBindPage: {
    title: 'Pengujian Iklan Dikuasakan AI',
    desc: 'Ramalan pantas prestasi kreatif iklan anda untuk memaksimumkan ROI menggunakan Model Bahasa Besar Multimodal Hypergraph (HMLLM)*',
    joinAdEff: 'Sertai AdEff dan Mulakan perjalanan baru',
    advantages: {
      title1: 'Lebih Berkuasa',
      desc1: 'model AI unik berdasarkan pangkalan data besar',
      title2: 'Lebih Jimat',
      desc2: 'hanya perlu 10% harga kaedah tradisional',
      title3: 'Lebih Laju',
      desc3: 'laporan boleh diperoleh seawal 15 minit',
      title4: 'Perkhidmatan Lebih Baik',
      desc4: 'akses sokongan 24/7 dan bantuan asas pakar secara percuma',
    },
    username: 'Nama Pengguna',
    company: 'Syarikat',
    placeOfResidence: 'Negara/Wilayah',
    invitationCode: 'Kod Rujukan',
    createAccountForFree: 'Buka akaun percuma',
    refreshStatus: 'Segar semula status',
    reapply: 'Mohon semula',
    bySigningUp: 'Dengan mendaftar, saya setuju dengan',
    termsOfService: 'Terma Perkhidmatan',
    and: 'dan',
    privacyPolicy: 'Polisi Privasi',
    message: {
      success: 'Permintaan untuk buka akaun telah dihantar, sila tunggu!',
      success2: 'Akaun berjaya dicipta',
      error: 'Ciptaan akaun gagal, sila cuba lagi kemudian.',
      accountCreatedDirectly: 'Akaun telah dicipta terus untuk anda!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Permohonan telah diluluskan dan sedang mengalihkan anda ke halaman seterusnya',
      theRequestHasBeenSendAndPleaseBePatient: 'Permintaan telah dihantar, sila sabar menunggu!',
      wrongRouting: 'Penghalaan salah, sistem telah mengubah arah secara automatik.',
      yourRequestHasBeenDeclined:
        'Permohonan anda telah ditolak. Anda boleh memohon semula untuk sertai pasukan atau cipta akaun baharu tanpa kod jemputan.',
      waitingForAdministratorReview: 'Menunggu semakan pentadbir',
      thisFieldIsRequired: 'Medan ini diperlukan',
      pleaseEnterTheResidence: 'Sila masukkan negara',
      invitationCodeDoesNotExist: 'Kod rujukan tidak sah',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Jika anda menggunakan melalui rujukan ejen, sila masukkan kod rujukan',
      pleaseEnterTheUsername: 'Sila masukkan nama pengguna',
      pleaseEnterTheCompanyName: 'Sila masukkan nama syarikat',
      needRegisterAgain: 'Operasi tidak normal, sila daftar semula',
      alreadyBind: 'Anda sudah mengikat organisasi, jangan ikat semula',
    },
  },
  knowledgeFormPage: {
    name: 'Nama Anda',
    email: 'Emel Anda',
    companyName: 'Nama Syarikat',
    department: 'Jabatan',
    role: 'Peranan',
    country: 'Negara',
    province: 'Wilayah',
    pleaseEnter: 'Sila masukkan',
    pleaseSelect: 'Sila pilih',
    pleaseEnterTheName: 'Sila masukkan nama anda',
    pleaseEnterTheEmail: 'Sila masukkan emel anda',
    pleaseEnterValidEmail: 'Sila masukkan emel yang sah',
    pleaseEnterTheCompanyName: 'Sila masukkan nama syarikat anda',
    pleaseSelectTheDepartment: 'Sila pilih jabatan anda',
    pleaseSelectTheRole: 'Sila pilih peranan anda',
    pleaseSelectTheCountry: 'Sila pilih negara anda',
    pleaseSelectTheProvince: 'Sila pilih wilayah anda',
    textIsRequired: 'Ruangan ini diperlukan',
    submit: 'Hantar',
    download: 'Muat turun',
    submitSuccess: 'Hantar berjaya',
    downloadSuccess: 'Muat turun berjaya',
    title1: 'Sila isikan maklumat anda untuk dapatkan sumber',
    title2: 'Sila pilih sumber untuk dimuat turun',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Muat turun Laporan',
      downloadBtnText: 'Muat turun PDF',
      content: 'Kandungan',
      theEnd: 'Tamat',
      thankYouForWatching: 'Terima kasih kerana menonton.',
      pdfProcessing: 'Memproses PDF...',
      pdfProcessingDesc:
        'Halaman PDF: {{count}}, dijangka mengambil masa {{seconds}} saat, klik simpan selepas ini, sila bersabar',
      pdfProcessingDesc2: 'Versi bahasa semasa belum diterjemahkan, tidak boleh jana PDF',
    },
    ppt: {
      downloadBtnText: 'Muat turun PPT',
      pptProcessingDesc: 'Sedang memproses fail PPT, sila bersabar',
      pptProcessingDesc2: 'Versi bahasa semasa belum diterjemahkan, tidak boleh jana PPT',
      pptProcessingDesc3: 'Fail PPT sedang dimuat turun, sila tunggu...',
      translateCompleted: 'Terjemahan PPT selesai',
      exportSuccess: 'Fail PPT berjaya dieksport',
      exportFailed: 'Eksport fail PPT gagal',
    },
    layout: {
      projectMenuText: 'Projek Pengujian Iklan',
      accountManagementText: 'Pengurusan Akaun',
      myAccountText: 'Akaun Saya',
      subscriptionText: 'Langganan',
      logout: 'Log keluar',
      dataDetails: 'Butiran Data',
      dataAnalysis: 'Analisis Data',
      dataOverview: 'Gambaran Keseluruhan Data',
      dataComparison: 'Perbandingan Data',
    },
    systemMessage: {
      title: 'Mesej Sistem',
      task: 'Tugas',
      system: 'Sistem',
      noRelevantContent: 'Tiada kandungan berkaitan ditemui',
      noMore: 'Tiada lagi pemberitahuan.',
    },
    projectPage: {
      createProject: 'Cipta Projek',
      searchPlaceholder: 'Cari nama Projek/Iklan/Jenama',
      sortLabel: 'Isih mengikut Indeks Keberkesanan Iklan',
      sortPlaceholder: 'Sila pilih kaedah pengisihan',
      sortOption1: 'Ikut urutan meningkat indeks kesan',
      sortOption2: 'Ikut urutan menurun indeks kesan',
      filterSort: 'Tapis & Isih',
      filterBenchmarkTitle: 'Tapis penanda aras',
      sortTitle: 'Isih',
      tabAllCreative: 'Semua Kreatif ({{count}})',
      tabGeneralCreative: 'Kreatif Biasa ({{count}})',
      tabSplashCreative: 'Kreatif Splash ({{count}})',
      generalCreativeLabel: 'Kreatif Biasa',
      splashCreativeLabel: 'Kreatif Splash',
      normTypePlaceholder: 'Sila pilih jenis norma',
      totalDesc: 'Projek iklan (jumlah {{total}})',
      noRelevantContent: 'Tiada kandungan berkaitan ditemui',
      loadMore: 'Muat lagi',
      projectCard: {
        delete: 'Padam',
        reanalyze: 'Analisa Semula',
        download: 'Muat turun',
      },
      delete: 'Padam',
      cancel: 'Batal',
      message: {
        deleteTitle: 'Peringatan Pemadaman',
        delete:
          'Selepas anda memadam projek ini, semua data berkaitan tidak lagi boleh diakses. Anda pasti mahu meneruskan?',
        delete1:
          'Projek ini adalah percubaan percuma, memadamnya tidak akan kembalikan peluang percubaan percuma',
        delete2:
          'Projek ini belum mula dianalisis. Selepas dipadam, kredit ujian anda akan dipulangkan',
        deleteSuccess: 'Berjaya dipadam!',
        analysisCountNotEnough:
          'Bilangan analisis tidak mencukupi, sila tambah nilai untuk teruskan.',
        analysisFailed: 'Analisis gagal, sila cuba lagi kemudian.',
        waitingQuestion:
          'Maksimum 3 projek boleh dianalisis serentak. Projek ini dimasukkan ke barisan menunggu dan akan dianalisis secara automatik kemudian.',
        landscapeQuickCompleted: 'Projek ujian pantas landskap anda telah selesai.',
        portraitQuickCompleted: 'Projek ujian pantas potret anda telah selesai.',
        landscapeSurveyCompleted: 'Projek insight mendalam landskap anda telah selesai.',
        portraitSurveyCompleted: 'Projek insight mendalam potret anda telah selesai.',
      },
    },
    projectCreatePage: {
      createProject: 'Cipta Projek',
      basicInformation: 'Maklumat Asas',
      projectType: 'Jenis Projek',
      projectName: 'Nama Projek',
      categoryType: 'Kategori',
      brandName: 'Nama Jenama',
      advertisingInformation: 'Maklumat Iklan',
      adName: 'Nama Iklan',
      targetMarketNorm: 'Norma Pasaran Sasaran',
      norm: 'Norma',
      brandNorm: 'Norma Jenama',
      taGender: 'Jantina Sasaran',
      targetMarket: 'Pasaran Sasaran',
      taAge: 'Umur Sasaran',
      next: 'Seterusnya',
      previous: 'Langkah Sebelumnya',
      confirmOrder: 'Sahkan Pesanan',
      estTime: 'Anggaran Masa',
      minutes: 'minit',
      consumption: 'Penggunaan untuk pesanan ini',
      testPoint: 'Titik Ujian',
      remaining: 'Baki',
      times: 'kali',
      type: 'Jenis',
      purchase: 'Pembelian',
      outputLanguage: 'Bahasa Keluaran',
      durationCategory: 'Jenis Kreatif',
      durationCategoryDesc: 'Metrik analisis berbeza mengikut jenis kreatif, sila pilih pilihan yang paling sesuai dengan kandungan anda.',
      durationCategoryOptions: {
        tenPlus: 'Kreatif Umum (10s+)',
        fiveToTen: 'Kreatif Pembuka (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Ujian Kreatif Iklan',
        adCreativeTestDesc:
          'Ujian maklum balas audiens terhadap iklan individu, serta analisis dan cadangan.',
        adCreativeSelection: 'Pemilihan Kreatif Iklan',
        adCreativeSelectionDesc:
          'Bandingkan maklum balas beberapa kreatif iklan untuk membuat pemilihan menyeluruh.',
        adCreativeEditing: 'Penyuntingan Kreatif Iklan',
        adCreativeEditingDesc:
          'AI secara pintar menapis titik sorotan daripada iklan dan menjana kandungan secara automatik.',
        launchingSoon: 'Akan Datang',
      },
      industryCategorySelect: {
        foodAndBeverageCategory: 'Kategori Makanan & Minuman',
        packagedFood: 'Makanan Bungkus',
        confectionery: 'Gula-gula',
        frozenMeals: 'Makanan Sejuk Beku',
        fastFood: 'Makanan Segera',
        beverage: 'Minuman',
        alcohol: 'Alkohol',
        dairy: 'Tenusu',
        grainAndSeasoning: 'Bijirin & Perasa',
        beverageMixes: 'Campuran Minuman',
        freshProduce: 'Hasil Segar',
        otherFoodAndBeverage: 'Lain-lain Makanan & Minuman',

        consumerElectronicsCategory: 'Kategori Elektronik Pengguna',
        mobilePhone: 'Telefon Bimbit',
        computer: 'Komputer',
        smartDevice: 'Peranti Pintar',
        phoneAccessories: 'Aksesori Telefon',
        computerAccessories: 'Aksesori Komputer',
        software: 'Perisian',
        camera: 'Kamera',
        officeSupplies: 'Kelengkapan Pejabat',
        otherConsumerElectronics: 'Elektronik Pengguna Lain',

        pharmaceuticalsAndHealthCareCategory: 'Kategori Farmaseutikal & Penjagaan Kesihatan',
        otcMedicine: 'Ubat OTC',
        prescriptionDrugs: 'Ubat Preskripsi',
        healthSupplements: 'Suplemen Kesihatan',
        pharmaceuticalCompanies: 'Syarikat Farmaseutikal',
        medicalDevices: 'Alat Perubatan',
        medicalServices: 'Perkhidmatan Perubatan',
        pharmacy: 'Farmasi',
        otherPharmaceuticalsAndHealthCare: 'Lain-lain Farmaseutikal & Kesihatan',

        beautyAndPersonalCareCategory: 'Kategori Kecantikan/Penjagaan Diri/Barang Pencuci',
        hairCare: 'Penjagaan Rambut',
        womenSkincare: 'Penjagaan Kulit Wanita',
        homeCleaning: 'Pembersihan Rumah',
        bodyCare: 'Penjagaan Badan',
        feminineCare: 'Penjagaan Wanita',
        oralCare: 'Penjagaan Mulut',
        menSkincare: 'Penjagaan Kulit Lelaki',
        makeup: 'Alat Solek',
        fragrances: 'Haruman',
        beautyServices: 'Perkhidmatan Kecantikan',
        otherBeautyAndPersonalCare: 'Lain-lain Kecantikan/Penjagaan Diri/Pembersihan',

        maternalAndInfantProductsCategory: 'Kategori Ibu & Bayi',
        babyFood: 'Makanan Bayi',
        babyCareEssentials: 'Keperluan Penjagaan Bayi',
        babyToys: 'Mainan Bayi',
        otherMaternalAndInfantProducts: 'Lain-lain Produk Ibu & Bayi',

        networkAndCommunicationCategory: 'Kategori Rangkaian & Komunikasi',
        mobileCarriers: 'Pembekal Telefon Bimbit',
        internetProviders: 'Pembekal Internet',
        telecomEquipment: 'Peralatan Telekomunikasi',
        otherNetworkAndCommunication: 'Lain-lain Rangkaian & Komunikasi',

        travelAndAccommodationCategory: 'Kategori Pelancongan/Penginapan',
        localTourism: 'Pelancongan Tempatan',
        bookingPlatform: 'Platform Tempahan',
        hotels: 'Hotel',
        airlines: 'Syarikat Penerbangan',
        airport: 'Lapangan Terbang',
        otherTravelAndAccommodation: 'Pelancongan & Penginapan Lain',

        vehiclesCategory: 'Kategori Kenderaan',
        motorVehicleProductsAndServices: 'Produk & Perkhidmatan Kenderaan Bermotor',
        carBrands: 'Jenama Kereta',
        dealerships: 'Pengedar',
        carFinance: 'Kewangan Kereta',
        evCar: 'Kereta Elektrik (EV)',
        motorcycle: 'Motosikal',
        onlineUsedCarMarketplace: 'Platform Kereta Terpakai Dalam Talian',
        carRentalPlatform: 'Platform Sewa Kereta',
        travelNavigation: 'Navigasi Perjalanan',
        bicycle: 'Basikal',
        otherVehicles: 'Kenderaan Lain',

        householdAppliancesCategory: 'Kategori Peralatan Rumah',
        majorAppliances: 'Peralatan Utama',
        healthAndPersonalCareAppliances: 'Peralatan Kesihatan & Penjagaan Diri',
        majorKitchenAndBathAppliances: 'Peralatan Dapur & Mandi Utama',
        smallKitchenAppliances: 'Peralatan Dapur Kecil',
        environmentalAppliances: 'Peralatan Alam Sekitar',
        cleaningAppliances: 'Peralatan Pembersihan',
        otherHouseholdAppliances: 'Peralatan Rumah Lain',

        retailAndServiceCategory: 'Kategori Runcit & Perkhidmatan',
        onlineRetailEcommerce: 'Runcit Atas Talian/E-dagang',
        departmentStores: 'Gedung Serbaneka',
        lifeServices: 'Perkhidmatan Kehidupan',
        retailServicesAndDelivery: 'Perkhidmatan Runcit/Penghantaran',
        supermarkets: 'Pasar Raya',
        otherRetailAndService: 'Runcit & Perkhidmatan Lain',

        apparelCategory: 'Kategori Pakaian & Aksesori',
        footwear: 'Kasut',
        clothing: 'Pakaian',
        watchesWatchRetail: 'Jam Tangan/Kedai Jam',
        jewelry: 'Barang Kemas',
        bags: 'Bagasi/Beg',
        eyewearOpticalStores: 'Cermin Mata/Kedai Optik',
        otherClothingAndAccessories: 'Pakaian & Aksesori Lain',

        homeImprovementAndFurnishingsCategory: 'Kategori Pengubahsuaian & Perabot Rumah',
        homeFurnishing: 'Perabot Rumah',
        homeImprovement: 'Pengubahsuaian Rumah',
        otherHomeImprovementAndFurnishings: 'Pengubahsuaian & Perabot Rumah Lain',

        financialAndInsuranceCategory: 'Kategori Kewangan & Insurans',
        bank: 'Bank',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Perkhidmatan Pelaburan & Kewangan',
        insurance: 'Insurans',
        otherFinancialAndInsurance: 'Kewangan & Insurans Lain',

        entertainmentAndLeisureCategory: 'Kategori Hiburan & Rekreasi',
        socialApp: 'Aplikasi Sosial',
        toysAndDolls: 'Mainan dan Patung',
        concerts: 'Konsert',
        events: 'Acara',
        movies: 'Filem',
        themeParks: 'Taman Tema',
        gambling: 'Perjudian',
        onlineGaming: 'Permainan Dalam Talian',
        tvChannels: 'Saluran TV',
        otherEntertainmentAndLeisure: 'Hiburan & Rekreasi Lain',

        industrialAndAgriculturalCategory: 'Kategori Industri & Pertanian',
        industrialSupplies: 'Keperluan Industri',
        agriculturalSupplies: 'Keperluan Pertanian',
        otherIndustrialAndAgricultural: 'Industri & Pertanian Lain',

        petLifeCategory: 'Kategori Haiwan Peliharaan',
        petFood: 'Makanan Haiwan Peliharaan',
        petSupplies: 'Keperluan Haiwan Peliharaan',
        otherPetLife: 'Industri Haiwan Peliharaan Lain',

        educationAndLearningCategory: 'Kategori Pendidikan & Pembelajaran',
        onlineLearning: 'Pembelajaran Atas Talian',
        schools: 'Sekolah',
        skillCourses: 'Kursus Kemahiran',
        tutoring: 'Tuisyen',
        universities: 'Universiti',
        otherEducationAndLearning: 'Pendidikan & Pembelajaran Lain',

        communityAndPublicServiceCategory: 'Kategori Komuniti & Perkhidmatan Awam',
        charityCampaigns: 'Kempen Amal',
        ngoAds: 'Iklan NGO',
        otherCommunityAndPublicService: 'Komuniti & Perkhidmatan Awam Lain',

        otherCategory: 'Kategori Lain',
        governmentAdvertising: 'Iklan Kerajaan',
        realEstateAdvertising: 'Iklan Hartanah',
        otherAdvertising: 'Iklan Lain',
      },
      genderSelect: {
        male: 'Lelaki',
        female: 'Perempuan',
        all: 'Semua',
      },
      targetMarketSelect: {
        China: 'China',
        HongKongChina: 'Hong Kong, China',
        MacauChina: 'Macau, China',
        TaiwanChina: 'Taiwan, China',
        Japan: 'Jepun',
        Korea: 'Korea',
        Mongolia: 'Mongolia',
        Singapore: 'Singapura',
        Thailand: 'Thailand',
        Vietnam: 'Vietnam',
        Malaysia: 'Malaysia',
        Philippines: 'Filipina',
        Indonesia: 'Indonesia',
        Cambodia: 'Kemboja',
        Laos: 'Laos',
        India: 'India',
        SaudiArabia: 'Arab Saudi',
        Turkey: 'Turki',
        Israel: 'Israel',
        UnitedArabEmirates: 'Emiriah Arab Bersatu',
        Qatar: 'Qatar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'United Kingdom',
        France: 'Perancis',
        Germany: 'Jerman',
        Netherlands: 'Belanda',
        Belgium: 'Belgium',
        Austria: 'Austria',
        Italy: 'Itali',
        Spain: 'Sepanyol',
        Portugal: 'Portugal',
        Greece: 'Greece',
        Sweden: 'Sweden',
        Norway: 'Norway',
        Finland: 'Finland',
        Denmark: 'Denmark',
        Estonia: 'Estonia',
        Latvia: 'Latvia',
        Russia: 'Rusia',
        Poland: 'Poland',
        CzechRepublic: 'Republik Czech',
        Hungary: 'Hungary',
        Romania: 'Romania',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Slovakia',
        Slovenia: 'Slovenia',
        Ukraine: 'Ukraine',
        UnitedStates: 'Amerika Syarikat',
        Canada: 'Kanada',
        Mexico: 'Mexico',
        Brazil: 'Brazil',
        LatinAmerica: 'Amerika Latin',
        Australia: 'Australia',
        NewZealand: 'New Zealand',
        Other: 'Lain-lain',
      },
      languageSelect: {
        english: 'Bahasa Inggeris',
        chinese: 'Bahasa Cina',
        japanese: 'Bahasa Jepun',
        korean: 'Bahasa Korea',
        french: 'Bahasa Perancis',
        traditionalChinese: 'Bahasa Cina (Tradisional)',
      },
      placeholder: {
        projectName: 'Sila masukkan nama projek',
        category: 'Pilih kategori',
        brandName: 'Sila masukkan nama jenama',
        adName: 'Sila masukkan nama iklan',
        norm: 'Sila pilih norma',
        taGender: 'Sila pilih jantina',
        targetMarket: 'Sila pilih pasaran sasaran',
        taAge: 'Sila pilih umur',
        lowerLimit: 'Had Bawah',
        upperLimit: 'Had Atas',
        outputLanguage: 'Sila pilih bahasa keluaran',
      },
      step: {
        step1: 'Masukkan Maklumat Projek',
        step2: 'Sahkan Maklumat Pesanan',
      },
      message: {
        success: 'Berjaya dicipta',
        videoDurationOver60s: 'Durasi video melebihi {{max}} saat',
        videoDurationLessThan10s: 'Durasi video kurang {{min}} saat',
        videoDurationNeedOver10s: 'Tempoh video mesti melebihi 10 saat',
        videoDurationNeedWithin5To10s: 'Tempoh video mesti antara 5 saat hingga 10 saat',
        videoDurationNotMatchDurationCategory: 'Tempoh video semasa tidak memenuhi jenis projek ini. Sila muat naik semula video dan cuba lagi.',
        videoUploadingCannotSwitchDurationCategory: 'Anda tidak boleh menukar jenis kreatif semasa video sedang dimuat naik. Sila tunggu sehingga muat naik selesai.',
        videoFormatOrDurationError: 'Tidak dapat membaca format atau tempoh video. Sila semak fail video dan cuba lagi.',
        videoSizeOver200M: 'Saiz video melebihi 256MB',
        videoLandscape: 'Video mesti dalam format landskap',
        videoPortrait: 'Video perlu dalam format potret',
        clickToUploadTestVideo: 'Klik untuk Muat Naik Video Ujian',
        uploadFailed: 'Muat naik gagal, sila cuba lagi',
        uploadDesc1: 'Menyokong fail video landskap dalam MP4, MOV',
        uploadDescPortrait: 'Menyokong fail video potret dalam MP4, MOV',
        uploadDesc2: 'dengan had saiz fail 256MB',
        formNotCompleted: 'Sila lengkapkan semua maklumat.',
        uploadAdVideo: 'Sila muat naik video iklan',
        inputInvalid: 'Input tidak sah',
        insufficientTestPoints: 'Cubaan ujian tidak mencukupi. Sila tambah nilai untuk teruskan.',
        reviewProjectInfo:
          'Sila semak maklumat projek anda dengan teliti. Setelah disahkan, maklumat tidak boleh diubah.',
        waitingDesc:
          'Sehingga 3 projek boleh dianalisis serentak. Projek tambahan akan dimasukkan ke barisan menunggu dan diproses mengikut urutan oleh sistem.',
        ageRangeInvalid: 'Julat umur hanya menyokong 20-55',
        normDesc: 'Manfaat hak cipta tanpa had, nilai penanda aras tersuai syarikat',
      },
    },
    projectDetailPage: {
      testResults: 'Keputusan Ujian',
      share: 'Kongsi',
      shareFailed: 'Perkongsian gagal',
      shareModal: {
        title: 'Kongsi',
        desc: 'Salin teks di bawah dan kongsikannya di media sosial.',
        saveImage: 'Simpan Imej',
        copyText: 'Salin Teks',
        copySuccess: 'Disalin',
        copyFailed: 'Gagal menyalin',
        textTemplate:
          'Wow! Kreatif AI saya menewaskan {{score}}% karya setara di AdEff! Data ialah bukti sebenar! Ujian Kreatif AI AdEff kini percuma. Semak skor anda di {{hostname}}. Dapatkan 5 ujian percuma, semoga anda menerima penilaian terbaik!',
      },
      sharePoster: {
        createdByYou: 'Dicipta oleh anda',
        scoreTemplate: 'Mengatasi <score>{{score}}</score> kreatif AIGC',
        statsAt: 'Statistik pada ',
        certification: 'Pensijilan Kreativiti',
        footerText:
          'Kami menantikan anda terus berkarya dan menghasilkan lebih banyak karya berkualiti!',
      },
      basicInformation: 'Maklumat Asas',
      waiting: 'Menunggu',
      ongoing: 'Sedang Berjalan',
      failed: 'Gagal',
      tryAgain: 'Cuba Lagi',
      videoAnalysisFailed: 'Analisis Video gagal',
      message: {
        projectNotFound: 'Projek tidak dijumpai',
      },
      primaryAnalysis: 'Prestasi Utama',
      detailAnalysis: 'Analisis Masa',
      heatmapAnalysis: 'Peta Panas',
      analysisStepDesc:
        'AI telah menyiapkan semua tugas analisis. Butiran terperinci adalah seperti berikut',
      analysisWaitingDesc:
        'Sehingga 3 projek boleh dianalisis pada satu masa. Projek tambahan akan berada dalam barisan menunggu dan diproses mengikut giliran oleh sistem.',
      aiTip: 'Kandungan laporan dihasilkan oleh AI untuk rujukan sahaja',
      subAnalysisDescription: {
        adVideoScore: 'Indeks AdEff',
        adVideoScoreDesc:
          'Indeks AdEff ialah penunjuk komprehensif keberkesanan iklan, mampu meramalkan kesan jualan jangka pendek dan panjang iklan.',
        norm: 'Norma',
        normDesc:
          'Penanda aras industri atau data sejarah, digunakan untuk perbandingan prestasi iklan secara mendatar.',
        attentionIndex: 'Indeks Perhatian',
        attentionIndexDesc:
          'Kepekatan perhatian visual audiens, mencerminkan keupayaan kandungan iklan menarik penonton.',
        emotionIndex: 'Indeks Emosi',
        emotionIndexDesc:
          'Pengaktifan emosi positif audiens, mencerminkan keupayaan iklan mencetuskan tindak balas emosi serta-merta.',
        cognitionIndex: 'Indeks Pengenalan',
        cognitionIndexDesc:
          'Tahap pemprosesan kognitif audiens, mencerminkan tahap penglibatan mereka dengan kandungan iklan.',
        theGolden3Seconds: '3 Saat Keemasan',
        theGolden3SecondsDesc: '3 saat pertama iklan sangat penting untuk kejayaan.',
        informationTransmission: 'Momen Mesej Utama',
        informationTransmissionDesc:
          'Mengukur keupayaan momen maklumat iklan menarik perhatian audiens dan merangsang minat.',
        brandRelevance: 'Momen Jenama',
        brandRelevanceDesc:
          'Mengukur keupayaan momen jenama menarik perhatian audiens dan merangsang minat.',
        interestStimulation: 'Momen Minat',
        interestStimulationDesc:
          'Masa kandungan utama yang mencetuskan resonans emosi dan kognisi aktif.',
        theEnding3Seconds: '3 Saat Terakhir',
        theEnding3SecondsDesc:
          'Berdasarkan peraturan puncak-akhir, 3 saat terakhir iklan penting untuk mengukuhkan perhatian penonton dan mengukuhkan penghantaran maklumat.',
      },
      infoDrawer: {
        basicInformation: 'Maklumat Asas',
        advertisingInformation: 'Maklumat Iklan',
        projectName: 'Nama Projek',
        brandName: 'Nama Jenama',
        category: 'Kategori',
        norm: 'Norma Pasaran Sasaran',
        normLabel: 'Norma',
        brandNorm: 'Norma Jenama',
        adName: 'Nama Iklan',
        taGender: 'Jantina Sasaran',
        targetMarket: 'Pasaran Sasaran',
        taAge: 'Umur Sasaran',
        ageRange: '{{start}} hingga {{end}} tahun',
        modify: 'Ubah',
        cancel: 'Batal',
        confirm: 'Sahkan',
      },
      videoView: {
        eyeMovementRatio: 'Indeks perhatian',
        cognitiveEngagement: 'Indeks pengenalan',
        emotionRecognition: 'Indeks emosi',
        subjectiveResponseCurve: 'Lengkung Respons Subjektif',
        realtimeData: 'Data Masa Nyata',
        panoramicData: 'Data Panoramik',
        indexAnalysis: 'Analisis Indeks',
        advantage: 'Kekuatan',
        disadvantage: 'Kelemahan',
        suggestions: 'Cadangan',
        adVideoScore: 'Indeks AdEff',
        norm: 'Norma',
        analysisStepTitle1: 'Penyahkodan Kandungan',
        analysisStepTitle2: 'Ramalan Maklum Balas',
        analysisStepTitle3: 'Integrasi Data',
        analysisStepTitle4: 'Inferens Kesimpulan',
        analysisStepDesc1: 'Penyahkodan visual, audio, teks dan struktur kandungan iklan.',
        analysisStepDesc2: 'Meramal pergerakan mata penonton dan respons EEG setiap saat.',
        analysisStepDesc3: 'Menggabungkan kandungan iklan dengan data respons audiens.',
        analysisStepDesc4: 'Menjana penilaian dan cadangan melalui model inferens.',
        keyResult: 'Keputusan Utama',
        videoChart: {
          videoFailed: 'Main balik video gagal',
          videoFailedAction:
            'Sila segar semula dan cuba lagi. Jika masalah berterusan selepas beberapa kali segar semula, sila hubungi kami untuk bantuan.',
        },
      },
      storyboardView: {
        summary: 'Ringkasan',
        advantages: 'Kekuatan',
        disadvantages: 'Kelemahan',
        suggestions: 'Cadangan',
        keyResult: 'Keputusan Utama',
        norm: 'Norma',
        theGolden3Seconds: '3 Saat Keemasan',
        informationTransmission: 'Momen Mesej Utama',
        brandRelevance: 'Momen Jenama',
        interestStimulation: 'Momen Minat',
        theEnding3Seconds: '3 Saat Terakhir',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Emel',
      username: 'Nama Pengguna',
      password: 'Kata Laluan',
      setPasswordToEnableEmailLogin:
        'Tetapkan kata laluan untuk membolehkan log masuk melalui emel',
      uid: 'UID',
      contactAndReceiveNotifications: 'Hubungi dan Terima pemberitahuan',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Terima emel mengenai kemas kini terkini AdEff dengan emel ini.',
      myWorkspace: 'Ruang Kerja Saya',
      newRequest: 'Permintaan Baharu',
      invitationCode: 'Kod Rujukan',
      userName: 'Nama pengguna',
      invitationCodeDesc:
        'Setiap pasukan mempunyai kod jemputan unik untuk permintaan ahli baru semasa pendaftaran',
      table: {
        userName: 'Nama Pengguna',
        email: 'Emel',
        operation: 'Operasi',
        admin: 'Pentadbir',
        remove: 'Keluarkan',
        deny: 'Tolak',
        approve: 'Luluskan',
      },
      message: {
        yourTeamIsFull:
          'Pasukan anda penuh. Hubungi kami untuk tambah keahlian atau keluarkan ahli lain.',
        invitationLinkSent: 'Pautan jemputan telah dihantar ke alamat emel ini!',
        removeReminder: 'Peringatan Pengeluaran',
        remove: 'Keluarkan',
        removeMember:
          'Selepas mengeluarkan ahli, kandungan yang dicipta oleh ahli itu akan kekal. Anda pasti mahu keluarkan ahli ini?',
        removeMemberSuccess: 'Ahli berjaya dikeluarkan!',
        ok: 'ok',
        contactUs: 'hubungi kami',
        applicationProcessedSuccessfully: 'Permohonan berjaya diproses!',
        notificationSettingsTurnedOn: 'Tetapan pemberitahuan diaktifkan',
        notificationSettingsTurnedOff: 'Tetapan pemberitahuan dinyahaktifkan',
        setPassword: 'Tetapkan Kata Laluan',
        passwordConfirm: 'Sahkan',
        passwordCancel: 'Batal',
        oldPassword: 'Kata Laluan Lama',
        newPassword: 'Kata Laluan Baru',
        pleaseEnterTheOldPassword: 'Sila masukkan kata laluan lama',
        pleaseEnterTheNewPassword: 'Sila masukkan kata laluan baru',
        incorrectEntryOfOriginalPassword: 'Kata laluan asal tidak betul',
        passwordUpdatedSuccessfully: 'Kata laluan berjaya dikemas kini',
        changeUsername: 'Tukar Nama Pengguna',
        confirm: 'Sahkan',
        cancel: 'Batal',
        username: 'Nama Pengguna',
        pleaseEnterTheNewUsername: 'Sila masukkan nama pengguna baharu',
        userNameUpdatedSuccessfully: 'Nama pengguna berjaya dikemas kini',
        addMemberToWorkspace: 'Tambah Ahli Baharu ke Ruang Kerja',
        notAdminOperate: 'Bukan admin, tiada kebenaran operasi',
        emailAddress: 'Alamat Emel',
        send: 'Hantar',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Kami akan menghantar emel jemputan ke alamat ini untuk pengesahan.',
        workspaceMemberShip: 'Keahlian Ruang Kerja',
        forMoreMembership: 'untuk keahlian tambahan',
        reachedTheCeiling: 'Bilangan ahli telah mencapai had.',
        incorrectMailboxFormat: 'Format emel tidak betul',
        member: 'Ahli',
        changeCorpNameTitle: 'Tukar Nama Syarikat',
        changeCorpNameLabel: 'Nama Syarikat',
        pleaseEnterTheCorpName: 'Sila masukkan nama syarikat',
        changeCorpNameSuccess: 'Nama syarikat berjaya ditukar',
        changeCorpNameFailed: 'Penukaran nama syarikat gagal',
        noPermission: 'Anda tidak mempunyai kebenaran menukar nama syarikat',
      },
    },
    subscriptionPage: {
      currentPlan: 'Pelan Semasa',
      getInvoice: 'Dapatkan invois anda',
      remainingTimes: 'baki kali',
      purchaseMore: 'Beli lebih',
      contactUs: 'Hubungi Kami',
      teamPlan: 'Perkhidmatan pasukan pakar',
      unlimited: 'Tanpa Had',
      dueDate: 'Tarikh Tamat',
      table: {
        usageRecords: 'Rekod Penggunaan',
        date: 'Tarikh',
        projectName: 'Nama Projek',
        projectType: 'Jenis Projek',
        usageCount: 'kali',
        userName: 'Nama Pengguna',
        noRelevantContent: 'Tiada kandungan berkaitan ditemui',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Projek Kreatif Biasa',
      regularCreative: 'Kreatif Biasa',
      splashCreativeProject: 'Projek Kreatif Splash',
      splashCreative: 'Kreatif Splash',
      projects: 'Projek',
      localNorm: 'Penanda Aras Tempatan',
      projectPassRate: 'Kadar Lulus Projek',
      passRate: 'Kadar Lulus',
    },
    dataDetailPage: {
      baseData: 'Data Asas',
      totalProjects: 'Jumlah Projek',
      totalProjectsDesc:
        'Jumlah projek sah yang mengambil bahagian dalam penilaian keberkesanan iklan.',
      localNormProjects: 'Projek Norma Tempatan',
      brandNormProjects: 'Projek Norma Jenama',
      normProject: 'Projek Norma Pasaran Sasaran',
      brandNormProject: 'Projek Norma Jenama',
      localNorm: 'Norma Tempatan',
      localNormDesc:
        'Purata indeks prestasi iklan kempen dengan negara anda sebagai pasaran sasaran.',
      norm: 'Norma',
      brandNorm: 'Norma Jenama',
      brandNormDesc: 'Purata indeks prestasi iklan dengan nilai penanda aras jenama anda.',
      localProjectPassRate: 'Kadar Lulus Projek Tempatan',
      projectPassRate: 'Kadar Lulus Projek',
      brandProjectPassRate: 'Kadar Lulus Projek Jenama',
      projectPassRateDesc:
        'Peratusan projek dengan skor indeks keberkesanan iklan melebihi nilai penanda aras berbanding jumlah projek yang dinilai.',
      advertisingEffectivenessIndexDistribution: 'Taburan Indeks Keberkesanan Iklan',
      advertisingEffectivenessIndexDistributionDesc:
        'Menunjukkan perkadaran projek dalam pelbagai julat indeks keberkesanan iklan.',
      item: 'item',
    },
    dataComparisonPage: {
      createCompare: 'Perbandingan Baharu',
      createCompareDesc: 'Pilih beberapa projek untuk dibandingkan, sehingga 10 projek.',
      startCompare: 'Mula Perbandingan',
      compareReport: 'Laporan Perbandingan',
      searchPlaceholder: 'Cari nama laporan perbandingan',
      emptyText: 'Belum ada laporan perbandingan. Pilih projek untuk dibandingkan dahulu.',
      searchEmptyText: 'Tiada laporan perbandingan ditemui.',
      deleteTitle: 'Padam Laporan Perbandingan',
      deleteConfirm: 'Anda pasti mahu memadam laporan perbandingan ini? Tindakan ini tidak boleh dibuat asal.',
      projectCount: '{{count}} projek',
    },
    dataComparisonStartPage: {
      back: 'Kembali',
      basicInfo: 'Maklumat Asas',
      reportName: 'Nama Laporan:',
      reportNamePlaceholder: 'Masukkan nama laporan perbandingan',
      norm: 'Penanda Aras:',
      normPlaceholder: 'Pilih penanda aras',
      normTip: 'Pilih penanda aras yang digunakan untuk perbandingan projek',
      selectProject: 'Pilih Projek',
      searchPlaceholder: 'Cari mengikut nama projek/iklan/jenama',
      selectedCountPrefix: ' Dipilih ',
      selectedCountSuffix: ' projek, sehingga {{max}} projek',
      startCompare: 'Mula Perbandingan',
      save: 'Simpan',
      cancel: 'Batal',
      maxSelectedWarning: 'Anda boleh memilih sehingga 10 projek',
      reportNameRequired: 'Masukkan nama laporan perbandingan',
      normRequired: 'Pilih penanda aras',
      projectRequired: 'Pilih projek',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Nama Laporan Perbandingan',
      reportNotFound: 'Laporan tidak ditemui',
      back: 'Kembali',
      modify: 'Edit',
      deletedProjectTip: 'Projek berikut: {{names}} telah dipadam. Selepas disahkan, laporan perbandingan akan dikemas kini dan projek yang dipadam akan dikeluarkan.',
      confirmDeletedProjects: 'Sahkan',
      metricScore: 'Skor Indikator',
      tabDimension: 'Lima Dimensi',
      tabMoment: 'Momen Utama',
      tabAttitude: 'Sikap Pengguna',
      adeffScore: 'Skor AdEff',
      brandName: 'Nama Jenama',
      projectName: 'Nama Projek',
      industry: 'Industri',
      targetMarket: 'Pasaran Sasaran',
      gender: 'Jantina TA',
      age: 'Umur TA',
      adProject: 'Projek Iklan',
      normLabel: 'Penanda Aras',
      mixedCreativeBenchmarkTip: 'Tiada penanda aras tersedia apabila membandingkan kreatif umum dan kreatif splash secara serentak.',
      emptyProject: 'Pilih projek untuk melihat data perbandingan',
      viewProjectDetail: 'Lihat Butiran Projek',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Daya Perhatian',
        infectivity: 'Daya Emosional',
        delivery: 'Daya Pesan',
        brand: 'Daya Merek',
        persuasion: 'Daya Persuasif',
        gazeRecognition: 'Pengenalan Tatapan',
        emotionRecognition: 'Pengenalan Emosi',
        engagementRecognition: 'Pengenalan Keterlibatan',
        goldenSeconds: '3 Saat Keemasan',
        brandMoment: 'Momen Jenama',
        productMoment: 'Momen Minat',
        messageMoment: 'Momen Mesej Utama',
        endingSeconds: '3 Saat Terakhir',
        likeability: 'Kesukaan',
        newInformation: 'Informasi Baru',
        messageRelevance: 'Relevansi Pesan',
        comprehension: 'Pemahaman',
        credibility: 'Kredibilitas',
        brandLinkage: 'Keterkaitan Merek',
        uniqueness: 'Keunikan',
        learnMoreIntent: 'Keinginan untuk Tahu Lebih Banyak',
        purchaseIntent: 'Niat Membeli',
        recommendIntent: 'Kemudahan Dibagikan',
        brandLikeabilityLift: 'Peningkatan Kesukaan Merek',
        purchaseIntentionLift: 'Peningkatan Niat Beli',
        attentionIndex: 'Indeks Perhatian',
        emotionIndex: 'Indeks Emosi',
        cognitionIndex: 'Indeks Pengenalan',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Proyek evaluasi kreatif TVC Anda telah selesai.',
        title: {
          text1: 'Pengujian Kreatif Iklan',
          text2: 'Laporan Pengujian',
        },
        flowAnalysis: {
          desc1: 'AdEff sedang mengurai iklan video Anda',
          desc2: 'Penguraian video selesai',
          desc3: 'Menganalisis perhatian visual konsumen',
          desc4: 'Menganalisis fokus visual berdasarkan profil konsumen',
          desc5: 'Membuat heatmap perhatian',
          desc6: 'Heatmap dinamis telah dibuat',
          desc7: 'Mengukur respons kognitif-neural',
          desc8: 'Melacak tatapan, emosi, dan keterlibatan detik demi detik',
          desc9: 'Membuat kurva respons neural',
          desc10: 'Kurva respons neural telah dibuat',
          desc11: 'Menganalisis performa pada momen kunci',
          desc12: 'Mengukur respons kognitif-neural selama: 3 detik emas, momen pesan, momen merek, puncak minat, dan 3 detik terakhir',
          desc13: 'Mensintesis metrik momen kunci',
          desc14: 'Analisis momen kunci selesai',
          desc15: 'Menganalisis sikap konsumen',
          desc16: 'Menganalisis sikap terhadap merek, produk, dan konten',
          desc17: 'Mensintesis metrik sikap',
          desc18: 'Metrik sikap selesai',
          desc19: 'Membuat skor lima daya pendorong',
          desc20: 'Skor lima daya pendorong siap',
          desc21: 'Analisis selesai! Laporan performa iklan Anda siap',
          terminology: {
            thumbExpand: 'Perluas thumbnail',
            thumbCollapse: 'Ciutkan thumbnail',
            gazeRecognition: 'Pengenalan Tatapan',
            gazeRecognitionDesc: 'Mengukur konsentrasi perhatian visual dan menunjukkan seberapa efektif elemen iklan menangkap fokus penonton.',
            emotionRecognition: 'Pengenalan Emosi',
            emotionRecognitionDesc: 'Mengukur emosi positif dan respons afektif langsung yang dipicu oleh iklan.',
            engagementRecognition: 'Pengenalan Keterlibatan',
            engagementRecognitionDesc: 'Mengukur imersi dan keterlibatan, mencerminkan investasi mental pada konten iklan.',
            theGolden3Seconds: 'Performa 3 Detik Emas',
            theGolden3SecondsDesc: 'Mengevaluasi efektivitas konten iklan selama 3 detik awal.',
            keyMessage: 'Performa Pesan Kunci',
            keyMessageDesc: 'Mengukur kemampuan momen informasi iklan untuk menangkap perhatian dan merangsang minat.',
            brand: 'Performa Merek',
            brandDesc: 'Menilai penangkapan perhatian khusus merek dan efektivitas keterlibatan.',
            interest: 'Puncak Minat',
            interestDesc: 'Mengidentifikasi puncak konten yang memicu resonansi emosional dan keterlibatan tinggi.',
            ending3Seconds: 'Performa 3 Detik Terakhir',
            ending3SecondsDesc: 'Mengevaluasi efektivitas konten iklan pada 3 detik terakhir.',
            score: 'Skor',
            benchmark: 'Tolok ukur',
            metrics: 'Metrik',
            attitudePart: {
              attitudeMetrics: 'Metrik Sikap',
              liking: 'Kesukaan',
              likingDesc: 'Mengukur sikap subjektif audiens dan tahap kesukaan keseluruhan terhadap iklan.',
              newInformation: 'Informasi Baru',
              newInformationDesc: 'Mengukur sama ada audiens merasakan mereka memperoleh maklumat bernilai yang sebelum ini tidak diketahui tentang jenama atau produk daripada iklan.',
              messageRelevance: 'Relevansi Pesan',
              messageRelevanceDesc: 'Mengukur sejauh mana audiens merasakan maklumat dalam iklan berkaitan secara langsung dengan diri mereka.',
              comprehension: 'Pemahaman',
              comprehensionDesc: 'Mengukur sama ada mesej utama iklan difahami dengan jelas, tepat dan mudah oleh audiens.',
              credibility: 'Kredibilitas',
              credibilityDesc: 'Mengukur sejauh mana audiens percaya bahawa maklumat yang disampaikan adalah benar, boleh dipercayai dan meyakinkan.',
              brandLinkage: 'Keterkaitan Merek',
              brandLinkageDesc: 'Mengukur keupayaan audiens untuk mengaitkan iklan dengan betul dan kuat kepada jenama tertentu.',
              uniqueness: 'Keunikan',
              uniquenessDesc: 'Mengukur sama ada iklan berjaya membina persepsi jelas bahawa jenama mempunyai keunikan yang berbeza dan bernilai berbanding pesaing.',
              willing: 'Keinginan untuk Tahu Lebih Banyak',
              willingDesc: 'Mengukur kemungkinan subjektif audiens untuk mengambil langkah aktif mengetahui lebih lanjut tentang jenama atau produk selepas menonton iklan.',
              purchase: 'Niat Membeli',
              purchaseDesc: 'Mengukur kemungkinan subjektif audiens untuk mempertimbangkan memilih atau membeli produk jenama pada masa hadapan.',
              share: 'Kemudahan Dibagikan',
              shareDesc: 'Mengukur kemungkinan subjektif audiens untuk berkongsi iklan atau maklumat jenama secara aktif dengan orang lain.',
              brandLikeLift: 'Peningkatan Kesukaan Merek',
              brandLikeLiftDesc: 'Mengukur arah dan tahap perubahan kesukaan keseluruhan terhadap jenama atau produk selepas pendedahan kepada iklan.',
              purchaseIntentLift: 'Peningkatan Niat Beli',
              purchaseIntentLiftDesc: 'Mengukur arah dan tahap perubahan kesediaan untuk mempertimbangkan pembelian produk jenama selepas pendedahan kepada iklan.',
            },
            dimensionPart: {
              forceDrives: 'Daya Pendorong',
              attension: 'Perhatian',
              emotionalImpact: 'Dampak Emosional',
              messageClarity: 'Kejelasan Pesan',
              brandPower: 'Kekuatan Merek',
              persuasion: 'Persuasi',
              attentionForce: 'Daya Perhatian',
              attentionForceDesc: 'Mengukur keupayaan iklan untuk menarik dan mengekalkan perhatian visual serta auditori audiens.',
              emotionalForce: 'Daya Emosional',
              emotionalForceDesc: 'Mengukur intensiti resonans emosi segera dan naluri serta turun naik emosi yang dicetuskan oleh kandungan iklan.',
              messageForce: 'Daya Pesan',
              messageForceDesc: 'Mengukur keberkesanan mesej teras iklan dikenal pasti dengan jelas, difahami dengan tepat dan diingati oleh audiens sasaran.',
              brandForce: 'Daya Merek',
              brandForceDesc: 'Mengukur keberkesanan iklan dalam mengukuhkan identiti jenama, meningkatkan kesukaan jenama dan membina hubungan jenama yang kuat.',
              persuasiveForce: 'Daya Persuasif',
              persuasiveForceDesc: 'Mengukur kuasa akhir iklan untuk mengubah persepsi pengguna dan mendorong niat tingkah laku.',
            },
            result: {
              results: 'Hasil',
              pass: 'Lulus',
              notPass: 'Tidak Lulus',
              adeffScore: 'Skor AdEff',
              adeffScoreDesc: 'Skor AdEff direka untuk mengukur keberkesanan keseluruhan iklan.',
              benchmarkDesc: 'Purata skor AdEff semua iklan yang dimuat naik dalam negara atau rantau iklan digunakan untuk menanda aras prestasi iklan.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Menunggu...',
            description: 'Sedang membuat laporan pengujian untuk Anda...',
          },
          generating: 'Sedang dibuat...',
          freeTrialLockText1:
            'Dalam mod percubaan, pratonton dan muat turun laporan penuh tidak tersedia.',
          freeTrialLockText2: 'Langgan untuk membuka kunci.',
        },
      },
    },
  },
  professor: {
    account: 'Akaun',
    password: 'Kata Laluan',
    login: 'Log masuk',
    expertReviews: 'Ulasan Pakar',
    adVideoScore: 'Indeks AdEff',
    subjectiveResponseCurve: 'Lengkung Respons Subjektif',
    indexAnalysis: 'Analisis Indeks',
    keyResult: 'Keputusan Utama',
    theGolden3Seconds: '3 Saat Keemasan',
    informationTransmission: 'Momen Mesej Utama',
    brandRelevance: 'Momen Jenama',
    interestStimulation: 'Momen Minat',
    theEnding3Seconds: '3 Saat Terakhir',
    heatMap: 'Peta Panas',
    suggestion: 'Cadangan',
    suggestion1: 'Cadangan',
    submit: 'Hantar',
    next: 'Seterusnya',
    summary: 'Ringkasan',
    advantages: 'Kekuatan',
    disadvantages: 'Kelemahan',
    option1: 'Dijangka',
    option2: 'Tidak Dijangka',
    resultJudgment: 'Penilaian Keputusan',
    placeholder: 'Sila masukkan cadangan',
    waitRateCount: 'Bilangan iklan untuk dinilai',
    unfinishedTitle: 'Pemberitahuan',
    unfinishedRate: 'Masih ada kandungan belum dinilai untuk projek ini, anda mahu keluar?',
    unfinishedConfirm: 'Teruskan penilaian',
    unfinishedCancel: 'Keluar',
    message: {
      submitSuccess: 'Terima kasih atas maklum balas anda',
      submitSuccess1: 'Anda telah selesai menilai projek ini, terima kasih atas maklum balas anda',
      loginSuccess: 'Log masuk berjaya',
      rateUnfinished:
        'Anda belum menilai kandungan semasa, sila lengkapkan sebelum beralih ke soalan seterusnya',
      rateLocation:
        'Kami telah secara automatik menandakan kandungan yang belum dinilai untuk anda',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Mohon Percubaan',
      title1: 'Percubaan Percuma',
      trial: 'Percubaan',
      hiddenBoxText1: 'Beberapa kekuatan, kelemahan dan cadangan telah dikesan',
      hiddenBoxText2: 'Langgan untuk dapatkan laporan penuh',
      hiddenBoxBtn: 'Langgan Sekarang',
      applyBox: {
        name: 'Nama Anda',
        tel: 'Nombor Telefon',
        department: 'Jabatan',
        role: 'Peranan',
        country: 'Negara',
        city: 'Bandar',
        pleaseEnter: 'Sila masukkan',
        pleaseSelect: 'Sila pilih',
        pleaseEnterTheName: 'Sila masukkan nama anda',
        pleaseEnterTheTel: 'Sila masukkan nombor telefon anda',
        pleaseEnterValidTel: 'Sila masukkan nombor telefon yang sah',
        pleaseEnterValidEmail: 'Sila masukkan emel yang sah',
        pleaseSelectTheDepartment: 'Sila pilih jabatan kami',
        pleaseSelectTheRole: 'Sila pilih peranan anda',
        pleaseSelectTheCountry: 'Sila pilih negara anda',
        pleaseEnterTheCity: 'Sila masukkan bandar anda',
        textIsRequired: 'Ruangan ini diperlukan',
        submit: 'Hantar',
        tip: 'Setiap syarikat hanya ada satu peluang percubaan percuma',
      },
      gotTrial: 'Anda telah dapat percubaan!',
      goPc: 'Sila ke laman web versi PC untuk cipta projek anda.',
      back: 'Kembali',
      country: {
        China: 'China',
        Japan: 'Jepun',
        Korea: 'Korea',
        Indonesia: 'Indonesia',
        Thailand: 'Thailand',
        Singapore: 'Singapura',
        Malaysia: 'Malaysia',
        Vietnam: 'Vietnam',
        Germany: 'Jerman',
        Britain: 'United Kingdom',
        France: 'Perancis',
        Italy: 'Itali',
        Russia: 'Rusia',
        Spain: 'Sepanyol',
        Turkey: 'Turki',
        America: 'Amerika Syarikat',
        Canada: 'Kanada',
        Brazil: 'Brazil',
        Other: 'Lain-lain',
      },
      department: {
        Brand: 'Jenama',
        Market: 'Pasaran',
        Marketing: 'Pemasaran',
        IT: 'IT',
        Procurement: 'Perolehan',
        Other: 'Lain-lain',
      },
      role: {
        President: 'Presiden/Nai Presiden/Pengurus Besar',
        CMO: 'CMO atau Pengurusan Tahap C Lain',
        Director: 'Pengarah Jabatan',
        Manager: 'Pengurus Jabatan',
        Other: 'Lain-lain',
      },
      message: {
        submitSuccess: 'Berjaya dihantar',
        submitFailed: 'Hantar gagal, sila cuba lagi kemudian',
      },
    },
    downloadPptRechargeModal: {
      title: 'Tidak boleh memuat turun',
      desc1: 'Muat turun tidak tersedia dalam mod percubaan',
      desc2: 'Langgan untuk dapatkan laporan penuh',
      btn: 'Langgan Sekarang',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Kod Rujukan',
      invitationCodeDesc1:
        'Maklumat kod rujukan tidak boleh diubah, sila hubungi kami jika mahu mengubah',
      invitationCodeDesc2: 'Jika anda menggunakan melalui rujukan ejen, sila masukkan kod rujukan',
      invitationCodePlaceholder: 'Sila masukkan kod rujukan',
      invitationCodeError: 'Kod rujukan tidak sah',
      invitationCodeSuccess: 'Berjaya diikat',
      ok: 'OK',
      cancel: 'Batal',
    },
    aigcPromotionModal: {
      title: 'Manfaat Pencipta AIGC',
      subTitle: 'Daftar sekarang untuk dapatkan <tmp>5</tmp> peluang penilaian video AI',
      desc1: 'Sertai Acara Ujian Kreatif AI AdEff untuk menilai kreatif anda.',
      desc2: 'Daftar sekarang dan tebus 5 ujian percuma serta-merta.',
      registerBtn: 'Daftar untuk dapatkan peluang ujian',
      tip: 'Hanya untuk pengguna baharu yang mendaftar melalui pintu masuk kempen Pencipta AIGC',
      floatTitle: 'Ujian percuma',
    },
  },
}

export default TRANSLATION
